export const BASE_AVATAR_SIZE = 40;
export const BASE_FONT_SIZE = 16;
export const BASE_LINE_HEIGHT = 22;
export const BASE_STATUS_SIZE = 12;
